import { apiGet, apiPost } from '@/utils/httpClient'

export const documentApi = {
    translateDocument(documentId: number, pageNumber: number, pageSize: number, useExternalTranslations: boolean) {
        return apiPost(`document/translateDocument?documentId=${documentId}&pageNumber=${pageNumber}&pageSize=${pageSize}&useExternalTranslations=${useExternalTranslations}`);
    },

    saveTranslationDrafts(documentId: number, includeEdited: boolean) {
        return apiPost(`document/saveTranslationDrafts?documentId=${documentId}&includeEdited=${includeEdited}`);
    },

    getUserDocuments(paging: any) {
        return apiPost('document/user', paging);
    },

    deleteDocument(documentId: any) {
        return apiPost(`document/deleteDocument?documentId=${documentId}`);
    },

    getDocumentsCount() {
        return apiGet('document/getDocumentsCount');
    },

    getSegmentCounts(documentId: number) {
        return apiGet(`document/segmentCounts/${documentId}`);
    }
}